import React from 'react'
import {withTranslation} from "react-i18next";
import {PushpinOutlined} from '@ant-design/icons'

import BButton from 'components/Form/Fields/BButton'

const WarningDeliveryAddress = ({t}) => {
  const changeDeliveryAddress = () => alert('WiP')

  return (
    <div className='notice warningDeliveryAddress'>
      <div>{t('You have to provide the exact delivery address.')}</div>
      <div><BButton red onClick={changeDeliveryAddress}><PushpinOutlined/> {t('CHANGE DELIVERY ADDRESS')}</BButton></div>
    </div>
  )
}

export default withTranslation()(WarningDeliveryAddress)
